// export interface GroupsProps {
//   userEmail: string;
// }

const Groups = () =>
  // {}: GroupsProps
  {
    return null;
  };
export default Groups;
